'use strict';

import AddressService from './AddressService';
import VisitService from './VisitService';
import PhoneUpdateService from './PhoneUpdateService';
import JobService from "@/services/address/JobService";

export var service = new AddressService();
export var visitService = new VisitService();
export var phoneUpdateService = new PhoneUpdateService();
export var jobService = new JobService();